import { render, staticRenderFns } from "./trainingPlan.vue?vue&type=template&id=3328e9fc&scoped=true&"
import script from "./trainingPlan.vue?vue&type=script&lang=js&"
export * from "./trainingPlan.vue?vue&type=script&lang=js&"
import style0 from "./trainingPlan.vue?vue&type=style&index=0&id=3328e9fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3328e9fc",
  null
  
)

export default component.exports